export default "__VITE_ASSET__drTQ8KlO__"